import React, { useRef } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { QmsDataTable } from "../_common/QmsDataTable";
import cmtStageActions from "../../../_actions/_qmsActions/cmtStageActions";
import QmsAdminModal_EditCmtStage from "./QmsAdminModal_EditCmtStage";
import qmsTeamActions from "../../../_actions/_qmsActions/qmsTeamActions";

export default function QmsAdminCmtStages(props) {
  const { divisionId } = props;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(cmtStageActions.getAll(divisionId));
    dispatch(qmsTeamActions.getAll(divisionId));
  }, [divisionId]);

  const cmtStages = useSelector((state) => state.qms.cmtStages[divisionId] || null);
  const qmsTeams = useSelector((state) => state.qms.qmsTeams[divisionId] || null);

  const columns = [
    {
      id: "title",
      numeric: false,
      disablePadding: true,
      label: "Title",
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Description",
    },
    {
      id: "duration",
      numeric: true,
      disablePadding: false,
      label: "Default Duration (d)",
    },
    {
      id: "owner",
      numeric: false,
      disablePadding: false,
      label: "Default Stage Owner",
      render: (rowData) => {
        if (!rowData.defaultOwnerTeamId)
          return (
            <span className="badge badge-secondary qms-admin__inline-list--item">
              (None)
            </span>
          );
        else {
          const qt = (qmsTeams || []).find(
            (t) => t.qmsTeamId === rowData.defaultOwnerTeamId
          );
          return (
            <span className="badge badge-info qms-admin__inline-list--item">
              {qt ? qt.name : "(N/A)"}
            </span>
          );
        }
      },
    },
  ];

  return (
    <QmsDataTable
      data={cmtStages}
      columns={columns}
      idName="cmtStageId"
      editModalComponent={<QmsAdminModal_EditCmtStage divisionId={divisionId} />}
      onDelete={(ids) => dispatch(cmtStageActions.removeRange(ids, divisionId))}
      isExpandable={false}
    />
  );
}
